import {usePathname} from 'next/navigation';
import {useCallback, useEffect, useState} from 'react';

import {AppType} from '@web-catalog/types';

import {useHeaderAppTypeValue} from '@web-catalog/store';

const GAMES_LINK_ORDER = 2;
export const APPS_LINK_ORDER = 1;
export const KIOSK_LINK_ORDER = 3;

const appTypeToLinkOrder = {
  [AppType.MAIN]: APPS_LINK_ORDER,
  [AppType.GAMES]: GAMES_LINK_ORDER,
};

export default function useActiveLinkOrder() {
  const pathName = usePathname();
  const currentAppType = useHeaderAppTypeValue();

  const computeOrder = useCallback(() => {
    if (!pathName) {
      return APPS_LINK_ORDER;
    }
    if (pathName.startsWith('/games')) {
      return GAMES_LINK_ORDER;
    }
    if (pathName.startsWith('/kiosk')) {
      return KIOSK_LINK_ORDER;
    }
    if (pathName.startsWith('/app/')) {
      return currentAppType ? appTypeToLinkOrder[currentAppType] : undefined;
    }
    return APPS_LINK_ORDER;
  }, [pathName, currentAppType]);

  const [order, setOrder] = useState(computeOrder);

  useEffect(() => {
    setOrder(computeOrder);
  }, [computeOrder]);

  return order;
}
